import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentClassificationListSelectContentTemplate from "@Broker/@HandlebarsTemplates/clients/applications/documents/document-classification-list/_document-classification-list-select-content.hbs";
import Select2 from "@Shared/components/inputs/select2";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationSelect",
  components: {
    Select2
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    classifications: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectDropdownParent: {
      type: String,
      default: ""
    },
    allowCreate: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: ""
    },
    loaderPosition: {
      type: String,
      default: "left"
    }
  },
  computed: {
    options() {
      return {
        closeOnSelect: true,
        templateResult: this.formatResult,
        placeholder: this.$t("documents.selectDocumentType"),
        allowClear: false,
        dropdownCssClass: "template-editor-classification-select form-group-material",
        matcher: this.matchCustom,
        dropdownParent: this.selectDropdownParent,
        escapeMarkup(markup) {
          return markup;
        }
      };
    },
    selectClass() {
      return this.loaderPosition;
    }
  },
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      const formattedData = data && _mapInstanceProperty(data).call(data, ref => {
        return {
          id: ref.documentTypeId || ref.documentRequestId,
          text: ref.title || ref.classification
        };
      });
      formattedData.unshift({
        id: "no-results-btn",
        text: ""
      });
      return formattedData;
    },
    matchCustom(params, data) {
      var _context;
      const isEmpty = _trimInstanceProperty($).call($, params.term) === "";
      // If there are no search terms, return all of the data
      if (isEmpty) {
        const isNoResults = data.id === "no-results-btn";
        return isNoResults ? null : data;
      }

      // Do not display the item if there is no 'text' property
      if (data.id === "no-results-btn" && this.allowCreate) {
        return data;
      }

      // `params.term` should be the term that is used for searching
      // `data.text` is the text that is displayed for the data object
      if (_indexOfInstanceProperty(_context = data.text.toLowerCase()).call(_context, params.term.toLowerCase()) > -1) {
        return data;
      }

      // Return `null` if the term should not be displayed
      return null;
    },
    formatResult(state) {
      const noResultsButton = state.id === "no-results-btn";
      if (noResultsButton) {
        state.text = this.allowCreate ? $(".template-editor-classification-select .select2-search__field").val() : this.$t("global.phrases.noResultsFound");
      }
      return $(DocumentClassificationListSelectContentTemplate(_objectSpread(_objectSpread({}, state), {}, {
        createNewText: this.$t("documents.createAsNewDocumentClassification"),
        noResultsButton: noResultsButton && this.allowCreate
      })));
    },
    handleChange(data) {
      this.$emit("change", {
        documentType: data.text,
        id: data.id
      });
      this.$refs.select.setValue(this.value);
    },
    showLoader(position) {
      return this.loading && this.loaderPosition === position;
    }
  }
});